import { Step } from 'types/wizard';
import { PratusStepper } from 'components/DesignSystems/PratusStepper/PratusStepper';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';

type Props = {
  steps: Step[];
  activeStep: Step;
  showHelperText: boolean;
  handleDismissHelperText: () => void;
  helperText: string;
};
export default function WizardSidebar({
  steps,
  activeStep,
  showHelperText,
  handleDismissHelperText,
  helperText,
}: Props) {
  return (
    <div className="d-flex flex-column justify-content-between align-items-start left-content h-100">
      <PratusStepper vertical activeStep={activeStep.id} steps={steps} />
      {showHelperText && (
        <div className="helper-text-container d-flex flex-column align-items-start">
          <span className="title d-flex align-items-center">
            <SharedIcon iconName="info" />
            <span className="title ms-1">Helper Text</span>
          </span>
          <span className="description">{helperText}</span>
          <button onClick={handleDismissHelperText} className="dismiss-btn">
            Dismiss
          </button>
        </div>
      )}
    </div>
  );
}
